import { LucideIconData } from '@lucide/angular';

export const AdvaniaSmallLogo: LucideIconData = {
    name: 'AdvaniaSmallLogo',
    node: [
        [
            'polygon',
            {
                points: '.85 9.85 7.77 5.66 .85 18.17 .85 9.85',
                key: '7qxv28',
            },
        ],
        [
            'polygon',
            {
                points: '15.74 .85 22.65 4.95 8.91 4.95 15.74 .85',
                key: '4vrqur',
            },
        ],
        [
            'polygon',
            {
                points: '15.74 9.53 8.89 5.34 22.65 5.34 15.74 9.53',
                key: 'ip6f3u',
            },
        ],
        [
            'polygon',
            {
                points: '15.92 9.85 22.84 5.66 15.92 18.17 15.92 9.85',
                key: 'eoopax',
            },
        ],
        [
            'polygon',
            {
                points: '23.15 14.15 16.23 18.34 19.81 11.88 23.15 5.83 23.15 14.15 23.15 14.15',
                key: 'jrodva',
            },
        ],
        [
            'polygon',
            {
                points: '8.07 5.83 8.07 14.15 1.15 18.34 8.07 5.83',
                key: '177oyp',
            },
        ],
        [
            'polygon',
            {
                points: '8.25 14.47 15.1 18.66 1.33 18.66 8.25 14.47',
                key: '952lc4',
            },
        ],
        [
            'polygon',
            {
                points: '8.25 23.15 1.34 19.03 15.09 19.03 8.25 23.15',
                key: 'rb5z3v',
            },
        ],
        [
            'polygon',
            {
                points: '8.42 5.84 14.31 16.6 15.27 18.34 8.43 14.15 8.43 5.84 8.42 5.84',
                key: '1gy56g',
            },
        ],
        [
            'polygon',
            {
                points: '8.73 5.66 15.57 9.85 15.57 18.17 8.73 5.66',
                key: 'vzmo9n',
            },
        ],
    ],
};
